let optionsConfigured = []
let totalOptionsRequired = document.getElementById("totalNumberOfOptions").value

function optionSelected(optionName) {
  if (!optionsConfigured.includes(optionName)) {
    optionsConfigured.push(optionName)
    if (optionsConfigured.length >= totalOptionsRequired) {
      unlockAtc()
    }
  }
}

function colorOptionSelected(optionName, color) {
  updateColorImages(color)
  if (!optionsConfigured.includes(optionName)) {
    optionsConfigured.push(optionName)
    if (optionsConfigured.length >= totalOptionsRequired) {
      unlockAtc()
    }
  }
}

function updateColorImages(color) {
  const colorLookup = 'color_' + color.replace(/\s+/g, '-').toLowerCase()
  const element = document.getElementById('Product-Slider');
  const children = element.children;
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    if (child.dataset.group != colorLookup && child.dataset.group != null && child.dataset.group != undefined) {
      child.style.display = 'none'
    } else {
      child.style.display = 'block'
    }
  }
}

function buttonOptionSelected(optionValue, optionName) {
  optionSelected(optionName)
  if (optionsConfigured.length < totalOptionsRequired) {
      //First make everything inactive
      const containers = document.getElementsByClassName("button-toggle");
      for (let i = 0; i < containers.length; i++) {
        containers[i].classList.remove('active');
        containers[i].firstElementChild.classList.remove('active');
      }
    
      //Now activate the relevant things
      document.querySelector('[data-option-value="' + optionValue + '"]').classList.add('active');
      document.querySelector('[data-option-value="' + optionValue + '"]').firstElementChild.classList.add('active');
  }
}

function unlockAtc() {
  const allAtcWarnings = document.getElementsByClassName('noDefaultMessage');
  for (let i = 0; i < allAtcWarnings.length; i++) {
    const warning = allAtcWarnings[i];
    warning.style.display = 'none';
  }
  
  const allAtcButtons = document.getElementsByClassName('single-add-to-cart-button');
  for (let i = 0; i < allAtcButtons.length; i++) {
    const button = allAtcButtons[i];
    button.disabled = false;
  }
}

function displayCorrectColorImages(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let noDefault = document.getElementById("no-default").value
    if (urlParams.get('variant') == null && noDefault == 'true') {
       	updateColorImages('Polished Stainless Steel') 
    }
}

window.onload += displayCorrectColorImages();